import './DashboardScreen.scss';
import ButtonComponent from "../../../shared/components/button/ButtonComponent";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../store/reducers";
import DashboardCardComponent from "../../../shared/components/dashboard-card-component/DashboardCardComponent";
import LinkComponent from "../../../shared/components/link/LinkComponent";
import {useCallback, useEffect, useState} from "react";
import {CommonService} from "../../../shared/services";
import momentTimezone from "moment-timezone";
import {ImageConfig} from "../../../constants";
import LoaderComponent from "../../../shared/components/loader/LoaderComponent";
import StatusCardComponent from "../../../shared/components/status-card/StatusCardComponent";
import moment from "moment-timezone";
import GeneralInfoCardComponent from "../../../shared/components/general-info-card/GeneralInfoCardComponent";
import ModalComponent from "../../../shared/components/modal/ModalComponent";
import SecureCheckoutComponent from "../../transaction/secure-checkout/SecureCheckoutComponent";

import InvoiceListComponent from "../invoice-list/InvoiceListComponent";
import FacilityDetailsComponent from "../../client-cases/facility-details/FacilityDetailsComponent";
import {useLocation, useNavigate} from "react-router-dom";
import UpcomingAppointmentsComponent from "../upcoming-appointments/UpcomingAppointmentsComponent";
import ClientResourcesListComponent from "../client-resources-list/ClientResourcesListComponent";
import ExpirationPopupComponent from "../expiration-popup/ExpirationPopupComponent";
import ProviderDetailsModalComponent
    from "../../book-appointment/facility-carousel/provider-details-modal/ProviderDetailsComponent";
import AlertCardComponent from "../../../shared/components/alert-card/AlertCardComponent";


interface DashboardMainLayoutScreenProps {

}

const AlertRedirectToMapping: any = {
    performance_onboarding_form: CommonService._routeConfig.ClientOnboarding(),
    therapy_onboarding_form: CommonService._routeConfig.ClientOnboarding(),
    link_unlink_approve_request: CommonService._routeConfig.ProfileLinking(),
    client_details_form: CommonService._routeConfig.ClientOnboarding(),
    add_waiver_form: CommonService._routeConfig.ClientResource(),
    renew_waiver_form: CommonService._routeConfig.ClientResource(),
    renew_authorization_to_disclose_form: CommonService._routeConfig.ClientResource(),
    renew_authorization_to_release_form: CommonService._routeConfig.ClientResource(),
}

const DashboardScreen = (props: DashboardMainLayoutScreenProps) => {

    const navigate = useNavigate();
    const location = useLocation();
    const {clientBasicDetails} = useSelector((state: IRootReducerState) => state.client);
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);

    const [nextAppointment, setNextAppointment] = useState<any>({});
    const [isNextAppointmentLoading, setIsNextAppointmentLoading] = useState<boolean>(false);
    const [isNextAppointmentLoadingFailed, setIsNextAppointmentLoadingFailed] = useState<boolean>(false);
    const [isNextAppointmentLoaded, setIsNextAppointmentLoaded] = useState<boolean>(false);
    const [getAppointmentAndBalanceCount, setGetAppointmentAndBalanceCount] = useState<any>({});
    const [isPayNowModalOpen, setIsPayNowModalOpen] = useState<boolean>(false);
    const [selectedId, setSelectedId] = useState<string>('');
    const [isContactUsModalOpen, setIsContactUsModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isExpirationModalOpen, setIsExpirationModalOpen] = useState(false);
    const [isProviderDetailsModalOpen, setIsProviderDetailsModalOpen] = useState(false);
    const [greetings, setGreetings] = useState<string>('');
    const [getAlertData, setGetAlertData] = useState<any>([]);

    const getUpcomingAppointmentDetails = useCallback(() => {
        setIsNextAppointmentLoading(true);
        setIsNextAppointmentLoadingFailed(false);
        setIsNextAppointmentLoaded(false);
        CommonService._appointment.GetUpComingAppointmentDetails({timezone: momentTimezone.tz.guess()})
            .then((response: any) => {
                setNextAppointment(response.data);
                setIsNextAppointmentLoadingFailed(false);
                setIsNextAppointmentLoaded(true);
            })
            .catch((error: any) => {
                setNextAppointment({});
                setIsNextAppointmentLoadingFailed(true);
                setIsNextAppointmentLoaded(false);
            })
            .finally(() => {
                setIsNextAppointmentLoading(false);
            })
    }, []);

    const getAlertDataDetails = useCallback(() => {
        const payload = {
            timezone: momentTimezone.tz.guess(),
        }
        CommonService._dashboard.GetAllAlertsDetails(payload)
            .then((response: any) => {
                setGetAlertData(response.data);
            }).catch((error: any) => {
            console.log(error);
            setGetAlertData([]);
        })

    }, []);

    useEffect(() => {
        getAlertDataDetails()
    }, [getAlertDataDetails]);

    useEffect(() => {
        if (currentUser?.is_form_expired) {
            setIsExpirationModalOpen(true)
        }
    }, [currentUser]);

    useEffect(() => {
        getUpcomingAppointmentDetails();
    }, [getUpcomingAppointmentDetails]);

    const getAppointmentAndBalanceCountDetails = useCallback(() => {
        setIsLoading(true);
        CommonService._dashboard.GetScheduledAndOutstandingBalanceCount()
            .then((response: any) => {
                setIsLoading(false);
                setGetAppointmentAndBalanceCount(response.data);
            })
            .catch((error: any) => {
                setIsLoading(false);
                setGetAppointmentAndBalanceCount({});
            })
    }, []);


    useEffect(() => {
        getAppointmentAndBalanceCountDetails()
    }, [getAppointmentAndBalanceCountDetails]);


    const getGreeting = useCallback(() => {
        const currentHour = new Date().getHours();

        if (currentHour >= 5 && currentHour < 12) {
            setGreetings("Good Morning");
        } else if (currentHour >= 12 && currentHour < 18) {
            setGreetings("Good Afternoon");
        } else {
            setGreetings("Good Evening");
        }
    }, []);

    useEffect(() => {
        getGreeting();
    }, [getGreeting]);

    const handleBookAppointment = useCallback(() => {
        if (currentUser?.independent_appointment_booking === 'Restricted') {
            setIsContactUsModalOpen(true)
        } else {
            navigate(CommonService._routeConfig.BookAppointmentRoute())
        }
    }, [currentUser, navigate]);

    const handleNavigateToAppointmentForm = useCallback(() => {
        navigate(CommonService._routeConfig.ClientOnboarding());
    }, [navigate]);


    console.log('next',nextAppointment)
    return (
        <div className="dashboard-main-layout-screen">
            <div className={"dashboard-header"}>
                <div className={"dashboard-header-name"}>
                    {greetings} {clientBasicDetails?.first_name}!
                </div>
                <ButtonComponent onClick={handleBookAppointment}>
                    Book Appointment
                </ButtonComponent>
            </div>
            <div>
                {
                    getAlertData.length > 0 && <div className={"alert-container"}>
                        {getAlertData?.map((item: any, index: number) => {
                            const mappedRoute = AlertRedirectToMapping[item?.redirect_to] || item?.redirect_to;

                            return <AlertCardComponent className={`${item?.type} mrg-bottom-20`} key={index} message={<>
                                <b>Action Required:</b> {item?.message}
                            </>} action={<LinkComponent
                                route={mappedRoute}>{item?.button_text}</LinkComponent>}/>
                        })}
                    </div>
                }
                {
                    isNextAppointmentLoading && <LoaderComponent/>
                }
                {
                    isNextAppointmentLoadingFailed &&
                    <StatusCardComponent title={"Failed to load upcoming appointment"}/>
                }
                {
                    isNextAppointmentLoaded && <>
                        <div className={'ts-row'}>
                            <div className={'ts-col-lg-9 ts-col-md-12 ts-col-sm-12 ts-col-xs-12'}>

                                <DashboardCardComponent
                                    title={"Your Next Appointment"}
                                    linkActions={<LinkComponent onClick={() => setIsProviderDetailsModalOpen(true)}>
                                        Know More
                                    </LinkComponent>}
                                    providerName={nextAppointment?.provider_details?.first_name ? nextAppointment?.provider_details?.first_name + " " + nextAppointment?.provider_details?.last_name : 'N/A'}
                                    imageUrl={Object.keys(nextAppointment)?.length > 0 ? 'https://images.unsplash.com/photo-1741070487520-907d1359cb95?q=80&w=2874&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' : ''}
                                    actions={Object?.keys(nextAppointment)?.length > 0 && <LinkComponent
                                        route={CommonService._routeConfig.AppointmentDetails(nextAppointment?._id) + '?referrer=' + location.pathname}>
                                        View Appointment Details
                                    </LinkComponent>}>
                                    {Object?.keys(nextAppointment)?.length > 0 ?
                                        <div className={"dashboard-card-content"}>
                                            <div className={'dashboard-card-content-entire-wrapper'}>
                                                <div className={'dashboard-card-content-wrapper'}>
                                                    <div className={"dashboard-card-content-image"}>
                                                        <ImageConfig.DashboardDocumentIcon/>
                                                    </div>
                                                    <div className={"dashboard-card-content-description"}>
                                                        {CommonService.capitalizeFirstLetter(nextAppointment?.category_details?.name)} - {CommonService.capitalizeFirstLetter(nextAppointment?.service_details?.name)}
                                                    </div>
                                                </div>
                                                <div className={'dashboard-card-right-content-wrapper'}>
                                                    <div
                                                        className={'dashboard-card-consultation-type pdd-left-20 pdd-right-20'}>
                                                        {nextAppointment?.record_type === 'medical_record' ? CommonService.capitalizeFirstLetter(nextAppointment?.appointment_type) : nextAppointment?.bundle_pack_details?.consultation_title}
                                                    </div>
                                                    <div className={'dashboard-card-date-time-wrapper'}>
                                                        <ImageConfig.DashboardClockIcon/>
                                                        <div className={'pdd-left-5'}>{nextAppointment?.duration} min
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className={'dashboard-card-content-entire-wrapper'}>
                                                <div className={'dashboard-card-content-wrapper'}>
                                                    <div className={"dashboard-card-content-image"}>
                                                        <ImageConfig.DashboardCalendarIcon/>
                                                    </div>
                                                    <div className={"dashboard-card-content-description"}>
                                                        {moment(nextAppointment?.appointment_date).format('DD-MMM-YYYY')}, {CommonService.getHoursAndMinutesFromMinutes(nextAppointment?.start_time)}
                                                    </div>
                                                </div>
                                                {!nextAppointment?.is_forms_filled && nextAppointment?.appointment_type !== 'followup_consultation' &&
                                                    <div className={'dashboard-card-right-content-wrapper  '}>
                                                        <div className={'dashboard-card-consultation-type no-white-space'}>
                                                            Appointment Forms:&nbsp;&nbsp;
                                                        </div>
                                                        <div
                                                            className={'dashboard-card-date-time-wrapper no-white-space pdd-0 mrg-left-0'}>
                                                            <ButtonComponent color={'accent'} size={'small'}

                                                                             onClick={handleNavigateToAppointmentForm}
                                                                             variant={'outlined'}>Fill
                                                                Now</ButtonComponent>
                                                        </div>
                                                    </div>}
                                            </div>
                                            <div className={'dashboard-card-content-entire-wrapper '}>
                                                <div className={'dashboard-card-content-wrapper facility-wrapper'}>
                                                    <div className={"dashboard-card-content-image"}>
                                                        <ImageConfig.DashboardFacilityIcon/>
                                                    </div>
                                                    <div className={"dashboard-card-content-description"}>
                                                        {nextAppointment?.facility_details?.name}
                                                        <div
                                                            className={'facility-address'}>{nextAppointment?.facility_details?.address?.address_line}{}, {nextAppointment?.facility_details?.address?.city}, {nextAppointment?.facility_details?.address?.state} {nextAppointment?.facility_details?.address?.zip_code} | {CommonService.formatPhoneNumber(nextAppointment?.facility_details?.primary_contact_info?.phone)}
                                                        </div>
                                                    </div>
                                                </div>
                                                {nextAppointment?.payment_status === 'unpaid' &&
                                                    <div
                                                        className={'dashboard-card-right-content-wrapper pay-now-wrapper'}>
                                                        <div
                                                            className={'dashboard-card-consultation-type no-white-space'}>
                                                            Payment Status:
                                                        </div>
                                                        <div
                                                            className={'dashboard-card-date-time-wrapper no-white-space mrg-left-0 pdd-0'}>
                                                            <ButtonComponent color={'error'} size={'small'}
                                                                             onClick={() => {
                                                                                 if (nextAppointment?.enable_pay_now === false) {
                                                                                     CommonService._alert.showToast('This appointment has been marked as cancelled or no-show. Payment is not allowed unless the status is updated by the admin.')
                                                                                 }else{
                                                                                 setIsPayNowModalOpen(true);
                                                                                 setSelectedId(nextAppointment?.invoice_details?._id);
                                                                             }}} variant={'outlined'}>
                                                                Pay Now</ButtonComponent>

                                                        </div>

                                                    </div>}

                                            </div>
                                            {(nextAppointment?.appointment_type !== 'initial_consultation' && nextAppointment?.record_type === 'medical_record') &&
                                                <div className={'dashboard-card-content-entire-wrapper pdd-bottom-10'}>
                                                    <div className={'dashboard-card-content-wrapper'}>
                                                        <div className={"dashboard-card-content-image"}>
                                                            <ImageConfig.DashboardCaseIcon/>
                                                        </div>
                                                        <div className={"dashboard-card-content-description"}>
                                                            {CommonService.getDateFromTimezone(nextAppointment?.case_details?.created_at, moment.tz.guess(), 'DD-MMM-YYYY')}{" "}
                                                            {"-"} {nextAppointment?.case_details?.injury_details?.map((injury: any, index: number) => {
                                                            return <>{" "}{injury.body_part_name} {injury.body_side ? `(${injury.body_side})` : ''}{index !== nextAppointment?.case_details?.injury_details?.length - 1 ? <>,</> : ''}</>
                                                        })}
                                                        </div>
                                                    </div>
                                                </div>}
                                            {
                                                nextAppointment?.record_type === 'performance_record' &&
                                                <div className={'dashboard-card-content-entire-wrapper pdd-bottom-10'}>

                                                    <div className={'dashboard-card-content-wrapper'}>
                                                        <div className={"dashboard-card-content-image"}>
                                                            <ImageConfig.DashboardCaseIcon/>
                                                        </div>
                                                        <div className={"dashboard-card-content-description"}>
                                                            {nextAppointment?.case_details?.program_focus ? <>{CommonService.getDateFromTimezone(nextAppointment?.case_details?.created_at, moment.tz.guess(), 'DD-MMM-YYYY')} - {nextAppointment?.case_details?.program_focus}</> : 'N/A'}
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div> :
                                        <div className={'no-data-found-wrapper'}>
                                            <StatusCardComponent title={"No upcoming appointment."}/>
                                        </div>
                                    }
                                </DashboardCardComponent>

                                <div className={'ts-row'}>
                                    <div className={'ts-col-lg-6 ts-col-md-6 ts-col-sm-4 ts-col-xs-12'}>
                                        <InvoiceListComponent/>
                                    </div>
                                    <div className={'ts-col-lg-6 ts-col-md-6 ts-col-sm-4 ts-col-xs-12'}>
                                        <ClientResourcesListComponent/>
                                    </div>
                                </div>
                            </div>

                            <div className={'ts-col-lg-3 ts-col-md-12 ts-col-sm-4 ts-col-xs-12`'}>
                                <div className={'ts-row'}>
                                    <div className={'ts-col-lg-6 ts-col-md-6 ts-col-sm-6 ts-col-xs-12'}>
                                        <GeneralInfoCardComponent
                                            loading={isLoading}
                                            value={getAppointmentAndBalanceCount?.total_appointments || 'N/A'}
                                            label={'Scheduled Appointments'}
                                            icon={<ImageConfig.DashboardCalendarIcon2/>}/>
                                    </div>
                                    <div className={'ts-col-lg-6 ts-col-md-6 ts-col-sm-6 ts-col-xs-12'}>
                                        <GeneralInfoCardComponent
                                            value={CommonService.convertToDecimals(getAppointmentAndBalanceCount?.outstanding_amount) || 'N/A'}
                                            label={'Outstanding Balance'}
                                            loading={isLoading}
                                            prefixIcon={'$'}
                                            icon={<ImageConfig.DashboardDollarIcon/>}/>
                                    </div>
                                    <div className={'ts-col-lg-12'}>
                                        <UpcomingAppointmentsComponent/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }


            </div>
            <ModalComponent isOpen={isPayNowModalOpen}
                            closeOnBackDropClick={true}
            >
                <SecureCheckoutComponent isComingFromListScreen={true}
                                         selectedId={selectedId}
                                         location={'dashboard'}
                                         refreshPaymentList={getUpcomingAppointmentDetails}
                                         setIsSecureCheckOutModalOpen={setIsPayNowModalOpen}
                                         appointmentDetails={nextAppointment}/>
            </ModalComponent>
            <ModalComponent isOpen={isContactUsModalOpen}
                            closeOnBackDropClick={true}
                            modalFooter={<ButtonComponent color={'accent'} className={'mrg-bottom-30 mrg-top-10'}
                                                          onClick={() => setIsContactUsModalOpen(false)}>
                                Close
                            </ButtonComponent>}
                            onClose={() => setIsContactUsModalOpen(false)}>
                <FacilityDetailsComponent
                    title={<>Online Booking Unavailable.<br/> Contact us to book an appointment.</>}/>
            </ModalComponent>
            <ModalComponent isOpen={isExpirationModalOpen}
                            modalFooter={<ButtonComponent onClick={handleNavigateToAppointmentForm} color={'accent'}
                                                          className={'mrg-bottom-25 mrg-top-30'}>
                                Fill/Review Forms
                            </ButtonComponent>}
            >
                <ExpirationPopupComponent/>

            </ModalComponent>
            <ModalComponent isOpen={isProviderDetailsModalOpen}
                            onClose={() => setIsProviderDetailsModalOpen(false)}>
                <ProviderDetailsModalComponent providerDetails={nextAppointment?.provider_details}
                                               setIsProviderDetailsModalOpen={setIsProviderDetailsModalOpen}/>
            </ModalComponent>

        </div>
    );
}
export default DashboardScreen;
